/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SalesDetailReqRecord } from './SalesDetailReqRecord';

/**
 * Class that define the BASE request payload for an operation
 */
export type OperationReqBaseDTO = {
    /**
     * Currency of the operation
     */
    currency: OperationReqBaseDTO.currency;
    saleItemDetail: Array<SalesDetailReqRecord>;
};

export namespace OperationReqBaseDTO {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
